import axios from 'axios'
import router from '../router/index.js'
import {
  Message
} from 'element-ui'
import {
  tokenFreshPost
} from '@/request/login.js'

const service = axios.create({
  baseURL: "http://xwt.softykt.net/",  // 正式域名
  // baseURL: "http://new.beebird.com.cn/",  // 测试域名
  // http://xwt.softykt.net/ 正式
  // http://new.beebird.com.cn/ // 测试
  timeout: 60000 * 10, // request timeout
  headers: {
    'Access-Control-Allow-Origin':'*'
  }
})

// 添加请求拦截器，在请求头中加token  
service.interceptors.request.use(
  config => {
    if (window.sessionStorage.getItem("Token")) {
      config.headers.Authorization = window.sessionStorage.getItem('Token')
    }
    return config
  },
  error => {
    return Promise.reject(error)
  })




// 添加响应拦截器，对返回结果做统一处理
service.interceptors.response.use(function (response) {
    // console.log(response)
    // if (response.data.code == 2001 || response.data.code == 2002) {
    //   Message.warning('您的登录状态已过期，请重新登录')
    //   // sessionStorage.removeItem('token')
    //   localStorage.removeItem('token')
    //   // localStorage.clear()
    //   setTimeout(() => {
    //     this.$router.push({ path: '/login' })
    //   }, 1500);
    // }
    // if (response.data.expires_in == 3600) {
      // let upData = {
      //   token: window.sessionStorage.getItem('Token')
      // }

      // tokenFreshPost(upData).then(res => {
      //   console.log(res)
      //   if (res.data.status == 'ok') {
      //     // window.sessionStorage.replace('Token', res.data.token)
      //     window.sessionStorage.setItem('Token', res.data.token)
      //   }
      // })
    // }
    return response

  },
  // 不是返回500错误的时候退回登录页面 token 2001 2002 提示重新登录
  function (error) {
    if (error.response.data.error.message == 'Unauthenticated.') {
      let upData = {
        token: window.sessionStorage.getItem('Token')
      }
      Message.error({ message: '您的登录状态已过期，请重新登录' });
      window.sessionStorage.removeItem('Token')
      window.sessionStorage.removeItem('menue');
      if(window.sessionStorage.getItem('path')){
        router.push({
          path: window.sessionStorage.getItem('path')
        })
      }else{
        router.push({
          path: '/login'
        })
      }
      
      // tokenFreshPost(upData).then(res => {
      //   console.log(res)
      //   if (res.data.expires_in == 3600) {
      //     // window.sessionStorage.replace('Token', res.data.token)
      //        window.sessionStorage.setItem('Token', res.data.token)
      //   }

      // })
      // localStorage.removeItem('token')
      // // 后续解开
      // sessionStorage.clear()
      // setTimeout(() => {
      //   router.push({
      //     path: '/login'
      //   })
      // }, 1500);
    }
    return Promise.reject(error)
  }
)

export default service